// Black Live Ferris Wheel palette (Phaser 0xRRGGBB numbers and CSS strings).
//
// Mirrors the brand ramp in lib/core/design_system/colors.dart and the
// :root variables in src/styles.css. The stage is the app's navy night
// (#08122F) because the game opens as a sheet over live rooms; the wheel art
// itself stays gold. All game colors live
// here; `dart run tool/color_audit.dart` flags literals elsewhere in src/.
export const ROYAL_FERRIS_THEME = Object.freeze({
  transparent: 'rgba(0,0,0,0)',
  shadow: 0x050b1f,
  ivory: 0xfffbf3,
  pearl: 0xfff8ec,
  champagne: 0xfee69a,
  champagneSoft: 0xfff1c7,
  gold: 0xfcba22, // brand Primary Gold
  goldBright: 0xfbe479, // brand Light Gold
  goldDeep: 0xb07a00,
  antiqueGold: 0xe09e00,
  royalBronze: 0x8a5f00,
  stageBlack: 0x08122f,
  stageDeep: 0x0e1a3f,
  stage: 0x1c2f61,
  stageWarm: 0x2a3f78,
  beige: 0xd1b494, // brand Warm Beige
  taupe: 0xd8c4b7, // brand Soft Taupe
  spinGlow: 0xfcba22,
  ruby: 0xd4092d, // brand Accent Red
  rubyBright: 0xff5a6e,
  emerald: 0x28c987, // win (functional)
  podShell: 0xfffbf3,
  podSeat: 0xfff1c7,
  podSeatGlow: 0xfff8ec,
  selectedRing: 0xfbe479,
  selectedRingInner: 0xfff8ec,
  badgeFill: 0x1a3272,
  badgeStroke: 0xfbe479,
  winnerRing: 0xfbe479,
  textIvory: '#fff8ec',
  textGold: '#fbe479',
  textDark: '#2a1f14',
  textInk: '#1a1206',
  textBronze: '#5c3f00',
  textRuby: '#b0071f',
  textMutedGold: '#d8c4b7',
  // Text-shadow / glow strings for Phaser `setShadow`.
  css: Object.freeze({
    pearlShadow: 'rgba(255,248,236,0.72)',
    spinGlow: 'rgba(252,186,34,0.95)',
    spinGlowStrong: 'rgba(252,186,34,0.98)',
    goldGlow: 'rgba(251,228,121,0.95)',
  }),
  glowRamp: Object.freeze({
    fast: 0xe09e00,
    mid: 0xfcba22,
    slow: 0xfbe479,
    final: 0xfff9e8,
  }),
  sparkles: Object.freeze([0xfbe479, 0xfff1c7, 0xfff8ec, 0xd1b494, 0xd4092d]),
  // Win celebration confetti (CSS colors).
  confetti: Object.freeze(['#fbe479', '#fff1c7', '#d1b494', '#d4092d', '#28c987', '#fff8ec']),
  // Debug overlay (dev builds only).
  debugText: '#7cff7c',
  debugBg: 'rgba(0,0,0,0.7)',
});
